export const SecretEnvValues = ['development', 'test', 'production'] as const;
export const SecretEnvShort = ['d', 'q', 'p'] as const;
export type SecretEnvShort = (typeof SecretEnvShort)[number];
export type SecretEnv = (typeof SecretEnvValues)[number];

export const envs: Record<SecretEnv, string> = {
  development: 'Development',
  test: 'Testing',
  production: 'Production'
} as const;

export const envMap: Record<SecretEnv, SecretEnvShort> = {
  development: 'd',
  test: 'q',
  production: 'p'
};

export const inverseEnvMap: Record<SecretEnvShort, SecretEnv> = {
  d: 'development',
  q: 'test',
  p: 'production'
};

export const networks: Record<SecretEnv, string> = {
  development: '127.0.0.0/8',
  test: '127.0.0.0/8',
  production: '127.0.0.0/8'
} as const;

export const issuers: Record<SecretEnv, string> = {
  development: 'https://miau.devopzz.ninja',
  test: 'https://miau.testzz.ninja',
  production: 'https://miau.eduzz.com'
} as const;
